/* eslint-disable no-unused-vars */
import BaseMiddleware from './BaseMiddleware'
import store from '@/store'

export default class SetLayoutMiddleware extends BaseMiddleware {
    /**
     * Avalia se deve executar este middleware ou não
     *
     * @param {Route} to de qual rota está vindo
     * @param {Route} _from para qual rota está indo
     *
     * @return {boolean} deve executar este middleware?
     */
    shouldRun(_to, _from) {
        return true
    }

    /**
     * Executa ações sobre esta rota
     *
     * @param {Route} _to de qual rota está vindo
     * @param {Route} _from para qual rota está indo
     *
     * @return {boolean} deve retornar false quando este middleware modifica a rota com next
     */
    handle(_to, _from, next) {
        if (_to.matched.some(record => record.meta.layout)) {
            store.dispatch('layout/setLayout', _to.meta.layout)

            return true
        }

        store.dispatch('layout/setLayout', 'app-layout')

        return true
    }
}
